<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="新密码：" prop="userPassword">
        <el-input style="width: 424px;" type="password" v-model="infoForm.userPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateSeleniumJourneyPassword } from '@/api/journeySetting'
export default {
  name: 'ShopPwd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:sessionStorage.getItem('token'),
      infoForm: {
        userPassword:''
      },
      rules: {
        userPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {

  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let infoForm = that.infoForm;
      if (infoForm.userPassword === '') {
        this.$message.error('请输入新密码')
        return false
      }
      var passData = {
        userPassword:infoForm.userPassword
      } 
      updateSeleniumJourneyPassword(passData).then((res) => {
        that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {}
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/setting/components/ChangePwd.vue